var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'dolch-dynamite'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    staticStyle: {
      "height": "100%",
      "position": "relative"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    class: {
      'barrel-stage': true,
      isMobile: _vm.isMobile
    }
  }, [_vm.currentRound && _vm.currentSection === 'barrel' ? _c('div', {
    staticClass: "typing-stage"
  }, _vm._l(_vm.currentRound.steps, function (step, index) {
    return _c('div', {
      key: step.id || index,
      class: ("td-container step-" + index)
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text": step.answer,
        "text-step": index
      }
    })], 1);
  }), 0) : _vm._e(), _c('div', {
    ref: "sparkContainer",
    staticClass: "spark-container"
  }, [_c('img', {
    attrs: {
      "alt": "Spark",
      "src": _vm.imagePaths.sparkPath
    }
  })]), _c('div', {
    ref: "fuseContainer",
    staticClass: "fuse-container"
  }, [_c('img', {
    attrs: {
      "alt": "Fuse",
      "src": _vm.imagePaths.fusePath
    }
  })]), _c('div', {
    staticClass: "barrel-container"
  }, [_c('div', {
    staticClass: "full-barrel"
  }, [_c('img', {
    attrs: {
      "alt": "Barrel",
      "src": _vm.imagePaths.barrelPath
    }
  })]), _c('div', {
    staticClass: "blow-up-barrel"
  }, [_c('img', {
    staticClass: "barrel-lid",
    attrs: {
      "alt": "Barrel lid",
      "src": _vm.imagePaths.barrelLidPath
    }
  }), _c('img', {
    attrs: {
      "alt": "Blown up barrel",
      "src": _vm.imagePaths.barrelBlownUpPath
    }
  })])])]), _vm.currentRound && _vm.currentSection === 'fireworks' ? _c('div', {
    staticClass: "fireworks-stage"
  }, _vm._l(_vm.currentRound.steps, function (step, stepIndex) {
    return _c('div', {
      key: step.id || stepIndex,
      staticClass: "td-container"
    }, [_c('div', {
      staticClass: "gradient-overlay"
    }), _c('img', {
      attrs: {
        "alt": "fireworks",
        "src": _vm.fireworksImage
      }
    }), _c('blinking-cursor-text', {
      class: ("type-line fireworks-step-" + stepIndex),
      attrs: {
        "text": step.answer,
        "text-step": stepIndex
      }
    })], 1);
  }), 0) : _vm._e()])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }